import React from 'react';
import { useAITTheme } from '../ui/theme';

const AirportIcon: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100">
      <path
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        d="M2.89,66.37l21.05,9.08c.22.11.44.33.66.66l8.97,20.94c.22.44.78.55,1.11.22l5.1-5.1c.22-.22.33-.55.33-.89l-1.77-17.06,15.73-15.18,16.51,33.9c.22.44.78.55,1.11.22l7.98-7.98c.22-.22.33-.55.33-.89l-5.65-44.76,14.51-13.96c4.43-4.21,7.31-9.75,8.53-15.73.78-4.32-2.99-8.09-7.2-7.2-5.87,1.22-11.3,4.1-15.51,8.42l-14.18,14.51-44.76-5.65c-.33,0-.66.11-.89.33l-7.98,7.98c-.33.33-.22.89.22,1.11l34.01,16.62-15.18,15.73-17.17-1.77c-.33,0-.66.11-.89.33l-5.1,5.1c-.44.22-.33.89.11,1Z"
      />
    </svg>
  );
};

export default AirportIcon;
